import { render, staticRenderFns } from "./cordx-tyfast-flu-a-b-covid-19-multiplex-rapid-test-otc.vue?vue&type=template&id=0e8bf6b4&scoped=true&"
import script from "./cordx-tyfast-flu-a-b-covid-19-multiplex-rapid-test-otc.vue?vue&type=script&lang=js&"
export * from "./cordx-tyfast-flu-a-b-covid-19-multiplex-rapid-test-otc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e8bf6b4",
  null
  
)

export default component.exports